



































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import Vuex from 'vuex';
import { extend } from "vee-validate";
import moment from "moment";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import DetalhesOrcamento from "./DetalhesOrcamento.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { statusOrcamentoList } from "@/models/orcamento-auto-online/StatusOrcamentosModel";
import { orcamentoAutoOnlineService } from "@/service/orcamento-auto-online/OrcamentoAutoOnlineService";
import { FiltroSolicitacaoOrcamentoModel } from "@/models/orcamento-auto-online/FiltroSolicitacaoOrcamentoModel";
import StatusOrcamentoModel from "@/models/orcamento-auto-online/StatusOrcamentosModel";
import { PaginationModel } from "@/models/commons/PaginationModel";
import AprovarModal from "./AprovarModal.vue";
import { filtroOrcamentoSolicitadoStore } from "@/store/orcamento-auto/FiltroOrcamentoSolicitado";

extend("dataMenorQue", (value: any, params) => {
  const args = params as any[];
  if (args[0] != undefined) {
    return moment(value)
      .startOf("day")
      .isBefore(moment(`${args[0]}`).startOf("day"))
      ? "O campo {_field_} não pode ser menor que a Data de"
      : true;
  } else {
    return true;
  }
});

@Component({
  components: {
    GsModalDialog,
    DetalhesOrcamento,
    ValidationObserver,
    ValidationProvider,
    AprovarModal,
  },
})
export default class OrcamentosSolicitados extends Vue {
  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
  };

  exibirDetalhes(id: number) {

    filtroOrcamentoSolicitadoStore.SET_DADOS_BASICOS(this.filtro); // save do state do filtro
  
    this.$router.push({
      name: "DetalhesOrcamento",
      params: { id: id.toString() },
    });
  }

  listaStatus = statusOrcamentoList;
  resultado = [];
  detalheOrcamento: any = {};

  _timerId: any = null;
  tempoAtualizacaoPagina: number = 10000;

  loading = false;
  dialogErro = false;
  @Provide("mensagemErro")
  mensagemErro = "";

  mounted() {
    if(this.$route.params.status) {     
      let statusOrcamento =  this.$route.params.status as StatusOrcamentoModel;
      this.filtro.dataInicio = '';
      this.filtro.dataFim = '';
      this.filtro.status = statusOrcamento;      
    } else {
      this.filtro = filtroOrcamentoSolicitadoStore.filtroAtual || {}; // read state do filtro
    }

    this.filtrar();
    this._timerId = setInterval(this.filtrar, this.tempoAtualizacaoPagina); 
  }

  destroyed() {
    clearInterval(this._timerId);
  }

  cabecalho = [
    {
      text: "Data/Hora",
      value: "dataCriacao",
      sortable: false,
      width: "15%",
    },
    {
      text: "Número do orçamento",
      value: "numeroOrcamento",
      sortable: false,
      width: "15%",
    },
    {
      text: "Veículo: placa/ modelo / cor",
      value: "veiculo",
      width: "20%",
      sortable: false,
    },
    { text: "Status", value: "status", width: "10%", sortable: false },
    {
      text: "Motivo recusa",
      value: "observacao",
      width: "15%",
      sortable: false,
    },
    {
      text: "Ações",
      value: "exibirDetalhes",
      width: "15%",
      sortable: false,
    },
  ];

  filtro: FiltroSolicitacaoOrcamentoModel = {
    status: undefined,
    dataFim: "",
    dataInicio: "",
  };
  options: PaginationModel = {
    page: 1,
    itemsPerPage: 5,
    itemsLength: 0,
  };

  @Watch("options.page")
  @Watch("options.itemsPerPage")
  @Watch("options.itemsLength")
  handlePagination() {
    this.filtrar();
  }

  filtrar() {
    this.$refs.filtroObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        orcamentoAutoOnlineService
          .pesquisar(this.filtro, this.options)
          .then((res) => {
            this.resultado = res;
            this.options.itemsLength = res.totalElements;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.mensagemErro = err;
            this.dialogErro = true;
          });
      }
    });
  }

  downloadPDFOrcamento(idOrcamento: number) {
    orcamentoAutoOnlineService
      .obterPDForcamento(idOrcamento)
      .then((res: any) => {
        this.loading = true;
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "orcamento.pdf");
        document.body.appendChild(link);
        link.click();
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
        this.dialogErro = true;
        this.mensagemErro = "Orçamento indisponível para o associado.";
      });
  }
}
